import { Section } from 'src/app/components/Elements/Section';

import { LogoSectionDesktop, LogoSectionMobile } from '../styles';

export const AsSeenSection = () => {
  return (
    <Section>
      <h1>As seen in</h1>
      <LogoSectionDesktop src="/public/press-logo-desktop.png" />
      <LogoSectionMobile src="/public/press-logo-mobile.png" />
    </Section>
  );
};
